import { FormValues, RequestFieldsValues } from "../types"
import { isString } from "lodash"

export const formatRequestData = (inputs: RequestFieldsValues, id: string) => {
  return {
    request_data: {
      inputs,
    },
    request_meta: {
      version_id: id,
      call_purpose: "Spark - API Tester",
      source_system: "SPARK",
      correlation_id: "",
      requested_output: null,
      service_category: "",
      compiler_type: "NodeGen",
    },
  }
}

export const prepareEditableJsonData = (id: string) => {
  return {
    request_data: {
      inputs: {
        AnnInterestRate: 0.04,
        DownPayment: 50000,
        FixedClosingCosts: 0,
        Gross_Income: 75000,
        MinDownPaymentPct: 0.2,
        MonthlyCar: 200,
        MonthlyCC: 100,
        MonthlyHOA: 50,
        MonthlyHomeIns: 50,
        MonthlyMortgageIns: 0,
        MonthlyOLoans: 0,
        MonthlyOMortgage: 0,
        MonthlyOther: 0,
        MonthlyOtherExp: 0,
        MonthlyStuLoan: 50,
        PctHomePriceDepreciable: 0.6,
        PptyTax: 200,
        TermOfMortgageYrs: 30,
        VarClosingCosts: 0.02,
        YrsToDepreciate: 27.5,
      },
    },
    request_meta: {
      version_id: id,
      call_purpose: "Spark - API Tester",
      source_system: "SPARK",
      correlation_id: "",
      requested_output: null,
      service_category: "",
      compiler_type: "NodeGen",
    },
  }
}

export const formatFormValues = (values: FormValues) => {
  return {
    Gross_Income: Number(values.Gross_Income),
    MaxHousingExpPct: Number(values.MonthlyStuLoan),
    MonthlyCar: isString(values.MonthlyCar) ? Number(values.MonthlyCar.replaceAll("%", "")) : values.MonthlyCar,
    MonthlyCC: Number(values.MonthlyCC),
    PptyTax: Number(values.PptyTax),
    MonthlyHomeIns: isString(values.MonthlyHomeIns)
      ? Number(values.MonthlyHomeIns.replaceAll("%", ""))
      : values.MonthlyHomeIns,
    VarClosingCosts: Number(values.VarClosingCosts),
    FixedClosingCosts: Number(values.FixedClosingCosts),
    TermOfMortgageYrs: Number(values.TermOfMortgageYrs),
    AnnInterestRate: isString(values.AnnInterestRate)
      ? Number(values.AnnInterestRate.replaceAll("%", ""))
      : values.AnnInterestRate,
    DownPayment: Number(values.DownPayment),
    MinDownPaymentPct: Number(values.MinDownPaymentPct),
    MonthlyHOA: Number(values.MonthlyHOA),
    MonthlyMortgageIns: Number(values.MonthlyMortgageIns),
    MonthlyOLoans: Number(values.MonthlyOLoans),
    MonthlyOMortgage: Number(values.MonthlyOMortgage),
    MonthlyOther: Number(values.MonthlyOther),
    MonthlyOtherExp: Number(values.MonthlyOtherExp),
    MonthlyStuLoan: Number(values.MonthlyStuLoan),
  }
}

